import React from 'react';
import { useTranslation } from 'react-i18next';

import { ExternalLinkItem } from './ExternalLinkItem';
import { providerConfig } from './constants';

type ExternalLinksLinkType = {
    url: string;
    provider: ProviderValuesType;
};

type ExternalLinksProp = {
    wikiUrl?: string;
    openInNewTab: boolean;
    links: ExternalLinksLinkType[];
};

// TODO: This logic should be done by a selector, but as the props and data passing and preperation is atm. quite complex it is done in the components context.
function sanatizeExternalLinks(links: ExternalLinksLinkType[], wikiEntry: ExternalLinksLinkType | null): any {
    if (!Array.isArray(links)) {
        return [];
    }
    const copy = [wikiEntry, ...links].filter((e) => e !== null);
    let officialFound = false;
    return copy.filter((link: ExternalLinksLinkType) => {
        if (link.provider === 'official' && officialFound) {
            return false;
        }
        officialFound = !officialFound && link.provider === 'official';
        return true;
    });
}

export function ExternalLinks(props: ExternalLinksProp): React.ReactElement<ExternalLinksProp> | null {
    const { links, wikiUrl, openInNewTab } = props;
    const { t } = useTranslation('common');

    const externalLinkElements = sanatizeExternalLinks(
        links,
        typeof wikiUrl === 'string'
            ? {
                  url: wikiUrl,
                  provider: 'wiki',
              }
            : null,
    ).map((entry, idx) => {
        const { provider, url } = entry;
        const target = openInNewTab ? '_blank' : '_self';
        const config = providerConfig[provider];
        return undefined !== config ? (
            <li key={provider + idx}>
                <ExternalLinkItem config={config} href={url} provider={provider} target={target} />
            </li>
        ) : null;
    });

    // no links at all, do not render
    if (externalLinkElements.length <= 0) {
        return null;
    }

    return (
        <>
            <h4 className="wikiBox__links-title">{t('read-more', 'Read More')}</h4>
            <ul className="wikiBox__links-list">{externalLinkElements}</ul>
        </>
    );
}
